import {Form} from 'react-bootstrap';

export default function LabelComponent({label, labelIcon}) {
  return (
    <>
    {labelIcon}
    <Form.Label className="font-weight-bold">{label}</Form.Label>
    </>
  );
}